import Banner3 from '@activities/MainActivity/components/Banner3';
import PopupBanners from '@components/PopupBanners';
import useUser from '@hooks/auth/useUser';
import useAppCustom from '@hooks/useAppCustom';
import { ActivityComponentType } from '@stackflow/react';
import { Fragment } from 'react';

import Banner2 from './components/Banner2';
import LoginCard from './components/LoginCard';
import MainBanners from './components/MainBanners';
import MainFooter from './components/MainFooter';
import MainLayout from './components/MainLayout';
import NearBy from './components/NearBy';
import QuickOrder from './components/QuickOrder';
import RecentOrders from './components/RecentOrders';
import Recommendation from './components/Recommendation';
import UserLoading from './components/UserLoading';
import UserRewards from './components/UserRewards';
import useAndroidBackButton from './hooks/useAndroidBackButton';
import useAndroidSafeArea from './hooks/useAndroidSafeArea';
import useItemColumn from './hooks/useItemColumn';
import useLifeCycleReIssue from './hooks/useLifeCycleReIssue';
import useOpenDialog from './hooks/useOpenDialog';
import usePermission from './hooks/usePermission';
import usePushMessage from './hooks/usePushMessage';
import useRegisterToken from './hooks/useRegisterToken';
import useSetProjectId from './hooks/useSetProjectId';
import useUpdateDau from './hooks/useUpdateDau';

const MainActivity: ActivityComponentType = () => {
  const { user, isLoading } = useUser();
  const {
    useMainBanner, useRecommend, useSecondBanner, useThirdBanner, useQuickMenu,
  } = useAppCustom().main;
  usePushMessage();
  useAndroidBackButton();
  useOpenDialog();
  useAndroidSafeArea();
  useRegisterToken();
  usePermission();
  useItemColumn();
  useSetProjectId();
  useUpdateDau();
  useLifeCycleReIssue();
  return (
        <MainLayout>
            {useMainBanner && (
                <MainBanners/>
            )}
            {user && (
                <Fragment>
                  {useQuickMenu ? (
                      <QuickOrder/>
                  ) : (
                      <Fragment>
                        <UserRewards/>
                        <RecentOrders/>
                      </Fragment>
                  )}
                </Fragment>
            )}
            {isLoading && (
                <UserLoading/>
            )}
           <NearBy/>
            {(!isLoading && !user) && (
                <LoginCard/>
            )}
            {useSecondBanner && (
                <Banner2/>
            )}
            {useThirdBanner && (
                <Banner3/>
            )}
            {useRecommend && (
                <Recommendation/>
            )}
          <MainFooter/>
          <PopupBanners/>
        </MainLayout>
  );
};

export default MainActivity;
